import React, { Component } from 'react';
import { Row, Input } from "antd";
import Table1 from "./5-1-1";
import Table2 from "./5-1-2";
import Table5 from "./5-1-5";

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            update: false,
        }
    }

    onChange = (value) => {
        this.setState({
            update: value
        });
    }

    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    5.2 Three Months Rolling Forecast 后三个月滚动预测
                </Row>
                <Table1 {...this.props} onChange={this.onChange} />
                <Table2 {...this.props} onChange={this.onChange} update={this.state.update} />
                <Table5 {...this.props} />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-2/index.js